export default "__VITE_ASSET__By6l1gjh__"